import CustomDialog from './CustomDialog';

export default CustomDialog;
